import { Box, CircularProgress, Stack, Typography } from "@mui/joy";
import { ModalBackdrop } from "@mui/joy/Modal/Modal";
import axios from "axios";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import React from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router";
import { collectionData } from "rxfire/firestore";
import { auth, db, onAuthStateChanged, signOut } from "../config/firebase";
import { convert, getNotification, getUserInfo } from "../config/services";
import {
  notification$,
  notificationall$,
  userinfo$,
  walletData$,
  walletInfos$,
} from "../redux/action";

export function DashboardIndex() {
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(true);

  const dispatch = useDispatch();
  let totalbalance = [];

  React.useEffect(() => {
    // setLoading(true);
    onAuthStateChanged(auth, (user) => {
      if (user) {
        //get notifications
        getNotification(user.uid);
        //get user infos
        getUserInfo(user.uid).subscribe((userData) => {
          const {
            btc_balance,
            xrp_balance,
            doge_balance,
            bnb_balance,
            tron_balance,
            poly_balance,
            sol_balance,
            avax_balance,
            arb_balance,
            eth_balance,
            usdt_balance,
            usdterc20_balance,
            usdtpoly_balance,
            usdtsol_balance,
            usdtavax_balance,
            usdtarb_balance,
            usdtbnb_balance,
            addressindex,
            suspended,
          } = userData;

          const isSuspended = suspended === true;
          if (isSuspended) {
            signOut(auth)
              .then(() => {
                console.log("Suspended");
                navigate("/auth/login");
              })
              .catch((error) => {
                console.log(error);
              });
          }

          //totalbalance
          totalbalance = [
            btc_balance,
            xrp_balance,
            doge_balance,
            bnb_balance,
            tron_balance,
            poly_balance,
            sol_balance,
            avax_balance,
            arb_balance,
            eth_balance,
            usdt_balance,
            usdterc20_balance,
            usdtpoly_balance,
            usdtsol_balance,
            usdtavax_balance,
            usdtarb_balance,
            usdtbnb_balance,
          ].reduce((prv, cur) => {
            return prv + cur;
          }, 0);

          dispatch(
            userinfo$({
              ...userData,
              id: user.uid,
              totalBalance: totalbalance,
            }),
          );

          const collectionRef = collection(db, "walletaddresses");

          getDocs(collectionRef).then((querySnapshot) => {
            const data = querySnapshot.docs[addressindex].data();
            const { btc, bnb, eth, trx, xrp, doge } = data;
            dispatch(walletInfos$(data));

            //get crypto info
            axios
              .get(
                `https://api.coingecko.com/api/v3/simple/price?ids=bitcoin%2Cethereum%2Cbinancecoin%2Ctron%2Ctether%2Csolana%2Carbitrum%2Cripple%2Cdogecoin%2Cbifrost-bridged-matic-bifrost%2Cavalanche-2&vs_currencies=usd&include_24hr_change=true`,
              )
              .then((res) => {
                (async function () {
                  convert.ready();
                  console.log(res.data);
                  var myArray = [
                    {
                      coinname: "Ripple",
                      cointype: "xrp_balance",
                      price: res.data.ripple.usd,
                      difference: res.data.ripple.usd_24h_change,
                      balance: xrp_balance,
                      balancecoin: convert.USD.XRP(`${xrp_balance}`),
                      code: "XRP",
                      codeswap: "XRP",
                      image: "./images/coins/xrp.png",
                      address: xrp,
                      network: "XRP",
                      thumbimage: "./images/coins/xrp.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "Dogecoin",
                      cointype: "doge_balance",
                      price: res.data.dogecoin.usd,
                      difference: res.data.dogecoin.usd_24h_change,
                      balance: doge_balance,
                      balancecoin: convert.USD.DOGE(`${doge_balance}`),
                      code: "DOGE",
                      codeswap: "DOGE",
                      image: "./images/coins/doge.png",
                      address: doge,
                      network: "DOGE",
                      thumbimage: "./images/coins/doge.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "BITCOIN",
                      cointype: "btc_balance",
                      price: res.data.bitcoin.usd,
                      difference: res.data.bitcoin.usd_24h_change,
                      balance: btc_balance,
                      balancecoin: convert.USD.BTC(`${btc_balance}`),
                      code: "BTC",
                      codeswap: "BTC",
                      image: "./images/coins/btc.png",
                      address: btc,
                      network: "BTC",
                      thumbimage: "./images/coins/btc.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "ETHERUEM",
                      cointype: "eth_balance",
                      price: res.data.ethereum.usd,
                      difference: res.data.ethereum.usd_24h_change,
                      balance: eth_balance,
                      balancecoin: convert.USD.ETH(`${eth_balance}`),
                      code: "ETH",
                      codeswap: "ETH",
                      image: "./images/coins/eth.png",
                      address: eth,
                      network: "ERC20",
                      thumbimage: "./images/coins/eth.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "BNB SMART",
                      cointype: "bnb_balance",
                      price: res.data.binancecoin.usd,
                      difference: res.data.binancecoin.usd_24h_change,
                      balance: bnb_balance,
                      balancecoin: convert.USD.BNB(`${bnb_balance}`),
                      code: "BNB",
                      codeswap: "BNB",
                      image: "./images/coins/bnb.png",
                      address: bnb,
                      network: "BEP20",
                      thumbimage: "./images/coins/bnb.png",
                      contractaddress: false,
                    },

                    {
                      coinname: "SOLANA",
                      cointype: "sol_balance",
                      price: res.data.solana.usd,
                      difference: res.data.solana.usd_24h_change,
                      balance: sol_balance,
                      balancecoin: convert.USD.SOL(sol_balance),
                      code: "SOL",
                      codeswap: "SOL",
                      image: "./images/coins/sol.png",
                      address: eth,
                      network: "Solana",
                      thumbimage: "./images/coins/sol.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "ARBITRUM",
                      cointype: "arb_balance",
                      price: res.data.arbitrum.usd,
                      difference: res.data.arbitrum.usd_24h_change,
                      balance: arb_balance,
                      balancecoin: convert.USD.ARB(arb_balance),
                      code: "ARB",
                      codeswap: "ARB",
                      image: "./images/coins/arb.png",
                      address: eth,
                      network: "Arbitrum",
                      thumbimage: "./images/coins/arb.png",
                      contractaddress: false,
                    },

                    {
                      coinname: "AVALANCHE",
                      cointype: "avax_balance",
                      price: res.data["avalanche-2"].usd,
                      difference: res.data["avalanche-2"].usd_24h_change,
                      balance: avax_balance,
                      balancecoin: convert.USD.AVAX(avax_balance),
                      code: "AVAX",
                      codeswap: "AVAX",
                      image: "./images/coins/avax.png",
                      address: eth,
                      network: "Avax",
                      thumbimage: "./images/coins/avax.png",
                      contractaddress: false,
                    },

                    {
                      coinname: "TRON",
                      cointype: "tron_balance",
                      price: res.data.tron.usd,
                      difference: res.data.tron.usd_24h_change,
                      balance: tron_balance,
                      balancecoin: convert.USD.TRX(`${tron_balance}`),
                      code: "TRX",
                      codeswap: "TRX",
                      image: "./images/coins/tron.png",
                      address: trx,
                      network: "TRC20",
                      thumbimage: "./images/coins/tron.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "USDT",
                      cointype: "usdt_balance",
                      price: res.data.tether.usd,
                      difference: res.data.tether.usd_24h_change,
                      balance: usdt_balance,
                      balancecoin: convert.USDT.USDT(`${usdt_balance}`),
                      code: "USDT TRC20",
                      codeswap: "USDT",
                      image: "./images/coins/usdt.png",
                      address: trx,
                      network: "TRC20",
                      thumbimage: "./images/coins/tron.png",
                      contractaddress: true,
                    },
                    {
                      coinname: "USDT",
                      cointype: "usdterc20_balance",
                      price: res.data.tether.usd,
                      difference: res.data.tether.usd_24h_change,
                      balance: usdterc20_balance,
                      balancecoin: convert.USDT.USDT(`${usdterc20_balance}`),
                      code: "USDT ERC20",
                      codeswap: "USDT",
                      image: "./images/coins/usdt.png",
                      address: eth,
                      network: "ERC20",
                      thumbimage: "./images/coins/eth.png",
                      contractaddress: true,
                    },

                    // for test purpose only
                    {
                      coinname: "USDT",
                      cointype: "usdtbnb_balance",
                      price: res.data.tether.usd,
                      difference: res.data.tether.usd_24h_change,
                      balance: usdtbnb_balance,
                      balancecoin: convert.USDT.USDT(`${usdtbnb_balance}`),
                      code: "USDT BSC",
                      codeswap: "USDT",
                      image: "./images/coins/usdt.png",
                      address: bnb,
                      network: "BEP20",
                      thumbimage: "./images/coins/bnb.png",
                      contractaddress: true,
                    },

                    {
                      coinname: "USDT",
                      cointype: "usdtsol_balance",
                      price: res.data.tether.usd,
                      difference: res.data.tether.usd_24h_change,
                      balance: usdtsol_balance,
                      balancecoin: convert.USDT.USDT(`${usdtsol_balance}`),
                      code: "USDT SOL",
                      codeswap: "USDT",
                      image: "./images/coins/usdt.png",
                      address: eth,
                      network: "Solana",
                      thumbimage: "./images/coins/sol.png",
                      contractaddress: true,
                    },
                    {
                      coinname: "USDT",
                      cointype: "usdtarb_balance",
                      price: res.data.tether.usd,
                      difference: res.data.tether.usd_24h_change,
                      balance: usdtarb_balance,
                      balancecoin: convert.USDT.USDT(`${usdtarb_balance}`),
                      code: "USDT ARB",
                      codeswap: "USDT",
                      image: "./images/coins/usdt.png",
                      address: eth,
                      network: "Arbitrum",
                      thumbimage: "./images/coins/arb.png",
                      contractaddress: true,
                    },
                    {
                      coinname: "USDT",
                      cointype: "usdtavax_balance",
                      price: res.data.tether.usd,
                      difference: res.data.tether.usd_24h_change,
                      balance: usdtavax_balance,
                      balancecoin: convert.USDT.USDT(`${usdtavax_balance}`),
                      code: "USDT AVAX",
                      codeswap: "USDT",
                      image: "./images/coins/usdt.png",
                      address: eth,
                      network: "Avax",
                      thumbimage: "./images/coins/avax.png",
                      contractaddress: true,
                    },
                  ];
                  myArray.sort((a, b) => b.balance - a.balance);
                  dispatch(walletData$(myArray));
                })().then(() => {
                  setLoading(false);
                });
              })
              .catch((error) => console.log(error));
          });
        });
        const usertransactionref = query(
          collection(db, "users", user.uid, "transactions"),
          // where("seen", "!=", true),
          orderBy("timestamp", "desc"),
        );
        const notifications = collectionData(usertransactionref).subscribe(
          (data) => {
            const getAllDocsWithoutField = (fieldName) => {
              const docsWithoutField = data.filter((doc) => {
                const data = doc;
                return !(fieldName in data);
              });

              return docsWithoutField;
            };
            dispatch(notificationall$(data.length));
            dispatch(notification$(getAllDocsWithoutField("seen").length));
          },
        );
        return () => {
          notifications.unsubscribe();
        };
      } else {
        navigate("/auth/login");
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <script src="//code.jivosite.com/widget/IBa1CXD5kF" async></script>
      </Helmet>
      {loading ? (
        <ModalBackdrop
          sx={{
            flexDirection: "column",
            backgroundColor: (theme) => theme.palette.background.paper,
            zIndex: 1000,
          }}
        >
          <Box
            mt={1}
            display={"flex"}
            justifyContent={"center"}
            position={"relative"}
            top={"40%"}
          >
            <Stack spacing={1} alignItems={"center "}>
              <CircularProgress color="primary" />
              <Typography level="body-lg">Loading...</Typography>
            </Stack>
          </Box>
        </ModalBackdrop>
      ) : (
        <Outlet />
      )}
    </>
  );
}

/*
 <Helmet>
      <script src="//code.tidio.co/y4qvyvglyyragn1zlquny8um9fpsgoyg.js" async></script>
      </Helmet>

      <Backdrop open={loading}>
        <CustomCirleLoader />
      </Backdrop>
*/
